import React, { Component } from "react";
import Script from "react-load-script";

class AllEvents extends Component {
	constructor(props) {
		super(props);
		this.state = { scriptLoaded: false };
	}
	handleScriptLoad() {
		this.setState({ scriptLoaded: true });
	}
	render() {
		let loading = <i className="fa fa-spinner"></i>;
		if (this.state.scriptLoaded === true) {
			loading = "";
		}
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Upcoming Events</h1>
					</div>
				</header>
				<section className="container">
					{loading}
					<div id="elvanto-calendar-3757"></div>
					<Script
						url="https://crckingston.elvanto.com.au/calendar_embed.js?c[]=410d5777-00f3-4956-859f-ce9f39da51ac&c[]=02f4ea0a-80d0-473f-aaed-5ae7ad70e5f8&fd=s&el_id=3757"
						/*onCreate={this.handleScriptCreate.bind(this)}
							onError={this.handleScriptError.bind(this)}*/
						onLoad={this.handleScriptLoad.bind(this)}
					/>
				</section>
			</section>
		);
	}
}

export default AllEvents;
